import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BagIcon: FC<Props> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="bag icon">
      {/* <title>bag icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.42596 5.53685C8.48493 3.94869 9.79064 2.67969 11.3932 2.67969H13.6739C15.2765 2.67969 16.5822 3.94869 16.6412 5.53685H17.7376C19.0924 5.53685 20.2481 6.02016 21.0614 6.8934C21.8691 7.76062 22.2832 8.95157 22.2832 10.2751V16.5819C22.2832 17.9054 21.8691 19.0964 21.0612 19.9636C20.2478 20.8368 19.0918 21.3201 17.7367 21.3201H7.3278C5.973 21.3201 4.81748 20.8368 4.00443 19.9634C3.19702 19.0962 2.7832 17.9052 2.7832 16.5819V10.2751C2.7832 8.95078 3.19927 7.75997 4.00732 6.89314C4.82081 6.02048 5.97593 5.53685 7.3278 5.53685H8.42596ZM9.9281 5.53685H15.139C15.0817 4.77757 14.4479 4.17969 13.6739 4.17969H11.3932C10.6192 4.17969 9.98538 4.77757 9.9281 5.53685ZM5.10452 7.91595C4.59833 8.45897 4.2832 9.26226 4.2832 10.2751V12.0027H8.89303C8.90565 12.0021 8.91834 12.0018 8.93111 12.0018C8.94388 12.0018 8.95658 12.0021 8.96919 12.0027H16.0882C16.1008 12.0021 16.1135 12.0018 16.1263 12.0018C16.139 12.0018 16.1517 12.0021 16.1643 12.0027H20.7832V10.2751C20.7832 9.26148 20.4691 8.45832 19.9637 7.9157C19.464 7.3791 18.7219 7.03685 17.7376 7.03685H7.3278C6.34745 7.03685 5.60527 7.37878 5.10452 7.91595ZM20.7832 13.5027H16.8763V14.8116C16.8763 15.2258 16.5405 15.5616 16.1263 15.5616C15.7121 15.5616 15.3763 15.2258 15.3763 14.8116V13.5027H9.68111V14.8116C9.68111 15.2258 9.34533 15.5616 8.93111 15.5616C8.5169 15.5616 8.18111 15.2258 8.18111 14.8116V13.5027H4.2832V16.5819C4.2832 17.5956 4.59717 18.3988 5.1023 18.9413C5.60179 19.4779 6.34357 19.8201 7.3278 19.8201H17.7367C18.7215 19.8201 19.4638 19.4778 19.9636 18.9412C20.4691 18.3986 20.7832 17.5955 20.7832 16.5819V13.5027Z"
        fill={props.fill || "currentColor" || "#000000"}
      ></path>
    </svg>
  );
};

export default BagIcon;
